import { IconButton } from '@material-ui/core';
import { IRON } from 'styles/Colors';
import { noop } from 'lodash';
import { TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import React, { useState } from 'react';

function Email({
  value,
  setValue,
  disabled = false,
  error = '',
  setError = noop,
  validate = noop
}) {
  const [touched, setTouched] = useState(false);
  const handleChange = (e) => {
    setValue(e.target.value);
    if (touched) {
      validate();
    }
  };

  const onBlur = () => {
    setTouched(true);
    validate();
  };

  const onClear = () => {
    setTouched(false);
    setError('');
    setValue('');
  };

  return (
    <TextField
      id='email'
      label='Email'
      type='text'
      css={{ width: '100%' }}
      variant='outlined'
      value={value}
      InputLabelProps={{
        style: { color: IRON }
      }}
      onChange={handleChange}
      FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
      disabled={disabled}
      onBlur={onBlur}
      InputProps={{
        endAdornment: value && (
          <IconButton onClick={onClear}>
            <ClearIcon />
          </IconButton>
        )
      }}
      error={!!error}
      helperText={error}
    />
  );
}
export default Email;
